import Glide from '@glidejs/glide';

const uccbGlideDefaults = {
	perView: 1,
	gap:	40, // 2.5rem = 40px
}

function uccbDestroyGlideSlider( el ){
	if( !el._glideInstance ){
		return;
	}

	el._glideInstance.destroy();
	delete el._glideInstance;
	delete el.dataset.glideMounted;

	uccbResetGlideTabindex( el );
}

function uccbGetInt( value, fallback ){
	const parsed = parseInt( value, 10 );
	return Number.isFinite( parsed ) ? parsed : fallback
}

function uccbGetOptions( el ){
	let perView			= uccbGetInt( el.dataset.glidePerView, uccbGlideDefaults.perView );
	let breakpointsPx	= window.uccbGetBreakpointsPx();

	return {
		// Set config
		type:		'slider',
		bound:		true,
		keyboard:	false,
		perTouch:	1,

		breakpoints: {
			[( breakpointsPx.lg || 1000 ) - 1]: {
				perView: Math.min( perView, 2 )
			},
			[( breakpointsPx.md || 782 ) - 1]: {
				perView: 1
			}
		},

		// Block-customisable config
		perView:	perView,
		gap:		uccbGetInt( el.dataset.glideGap, uccbGlideDefaults.gap ),
	}
}

const uccbGlideSetSliderMode = el => uccbSwitchGlideMode( el );
const uccbGlideSetGridMode = el => uccbSwitchGlideMode( el, false );

function uccbInitGlideSliders( root = document ){
	root.querySelectorAll( '.uccb-glide' ).forEach( el => {
		if( uccbIsResponsiveGlideSlider( el ) ){
			uccbInitResponsiveGlideSlider( el );
			return;
		}

		uccbMountGlideSlider( el );
	});
}

function uccbInitResponsiveGlideSlider( el ){
	if( el._glideResponsiveInitialised ){
		uccbSyncResponsiveGlideSlider( el );
		return;
	}

	const breakpointsPx = window.uccbGetBreakpointsPx();
	let crossoverBreakpointPx = breakpointsPx[el.dataset.crossoverBreakpoint] || null;

	if( !crossoverBreakpointPx ){
		uccbMountGlideSlider( el );
		return;
	}

	const mediaQuery = window.matchMedia( `(max-width: ${ crossoverBreakpointPx - 1 }px)` );
	const onChange = () => uccbSyncResponsiveGlideSlider( el );

	el._glideMediaQuery = mediaQuery;
	el._glideMediaQueryHandler = onChange;
	el._glideResponsiveInitialised = true;

	mediaQuery.addEventListener( 'change', onChange );
	onChange();
}

function uccbIsResponsiveGlideSlider( el ){
	return (
		'true' === el.dataset.enableGrid
		&& 'string' === typeof el.dataset.crossoverBreakpoint
		&& '' != el.dataset.crossoverBreakpoint
	);
}

function uccbMountGlideSlider( el ){
	if( el._glideInstance ){
		uccbGlideSetSliderMode( el );
		uccbUpdateGlideTabindex( el._glideInstance );
		return el._glideInstance;
	}

	const glide = new Glide( el, uccbGetOptions( el ) );
	glide.on( ['mount.after', 'run.after', 'resize', 'update'], () => uccbUpdateGlideTabindex( glide ) );
	glide.mount();

	el._glideInstance = glide;
	el.dataset.glideMounted = 'true';
	uccbGlideSetSliderMode( el );

	return glide;
}

function uccbResetGlideTabindex( el ){
	el.querySelectorAll( '.glide__slide' ).forEach( slide => {
		slide.removeAttribute( 'inert' );
		slide.removeAttribute( 'aria-hidden' );
	});
}

function uccbSwitchGlideMode( el, slider = true ){
	el.dataset.mode = slider ? 'slider' : 'grid';
}

function uccbSyncResponsiveGlideSlider( el ){
	if( !el._glideMediaQuery ){
		return;
	}

	if( el._glideMediaQuery.matches ){
		uccbMountGlideSlider( el );
		return;
	}

	uccbDestroyGlideSlider( el );
	uccbGlideSetGridMode( el );
}

function uccbGetGlideRoot( glide ){
	return ( glide.selector instanceof HTMLElement ) ? glide.selector : document.querySelector( glide.selector );
}

function uccbUpdateGlideTabindex( glide ){
	const root = uccbGetGlideRoot( glide );
	
	if( !root ){
		console.warn( 'Glide tabindex - no root' );
		return;
	}

	const slides	= [...root.querySelectorAll( '.glide__slide:not( .glide__slide--clone )' )];
	const clones	= root.querySelectorAll( '.glide__slide--clone' );
	const perView	= Number( glide.settings.perView || 1 );
	const start		= glide.index;
	const end		= start + perView;

	clones.forEach( slide => {
		slide.setAttribute( 'inert', '' );
		slide.setAttribute( 'aria-hidden', 'true' );
	});

	slides.forEach( ( slide, index ) => {
		const isVisible = ( index >= start ) && ( index < end );

		slide.toggleAttribute( 'inert', !isVisible );
		slide.setAttribute( 'aria-hidden', isVisible ? 'false' : 'true' );
	});
}

document.addEventListener( 'DOMContentLoaded', () => uccbInitGlideSliders() );

if( window.wp?.domReady ){
	window.wp.domReady( () => uccbInitGlideSliders() );
}

window.uccbInitGlideSliders = uccbInitGlideSliders;